<template>
  <div>
    <section class="user_profile_change text_center base_text_style">
      <h2 class="header_underline">鑑定基本情報変更</h2>

      <ValidationObserver ref="form">
        <form
          action=""
          method="post"
          class="form"
        >
          <div class="form_group">
            <ValidationProvider name="ニックネーム" rules="required|max:50" v-slot="{ errors }">
              <label>ニックネーム</label>
              <input
                type="text"
                name="nickname"
                placeholder="ニックネームを入力してください"
                v-model="form.nickname"
              />
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider name="性別" rules="" v-slot="{ errors }">
              <label>性別</label>
              <div class="select">
                <select
                  name="gender"
                  :class="{
                    select_placeholder: true,
                    selected: form.gender !== 'u'
                  }"
                  v-model="form.gender"
                >
                  <option
                    v-for="(entry, index) in genders"
                    :key="index"
                    :value="entry.value"
                  >
                    {{ entry.label }}
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider vid="birthYear" name="生年月日(年)" rules="birthNumber" v-slot="{ errors }">
              <label>生年月日(年)</label>
              <div class="select">
                <select
                  name="birth_year"
                  :class="{
                    select_placeholder: true,
                    selected: form.birthYear !== 0
                  }"
                  v-model="form.birthYear"
                >
                  <option value="0">生まれた年を選択してください</option>
                  <option
                    v-for="(entry, index) in years"
                    :key="index"
                    :value="entry"
                  >
                  {{ entry }}年
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider vid="birthMonth" name="生年月日(月)" rules="birthNumber" v-slot="{ errors }">
              <label>生年月日(月)</label>
              <div class="select">
                <select
                  name="birth_month"
                  :class="{
                    select_placeholder: true,
                    selected: form.birthMonth !== 0
                  }"
                  v-model="form.birthMonth"
                >
                  <option value="0">生まれた月を選択してください</option>
                  <option
                    v-for="(entry, index) in months"
                    :key="index"
                    :value="entry"
                  >
                  {{ entry }}月
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider
              vid="birthDay"
              name="生年月日(日)"
              :rules="{
                birthNumber: true,
                birthDate: {
                  year: '@birthYear',
                  month: '@birthMonth'
                }
              }"
              v-slot="{ errors }"
            >
              <label>生年月日(日)</label>
              <div class="select">
                <select
                  name="birth_day"
                  :class="{
                    select_placeholder: true,
                    selected: form.birthDay !== 0
                  }"
                  v-model="form.birthDay"
                >
                  <option value="0">生まれた日を選択してください</option>
                  <option
                    v-for="(entry, index) in days"
                    :key="index"
                    :value="entry"
                  >
                  {{ entry }}日
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider name="血液型" rules="" v-slot="{ errors }">
              <label>血液型</label>
              <div class="select">
                <select
                  name="blood_type"
                  :class="{
                    select_placeholder: true,
                    selected: form.bloodType !== 'U'
                  }"
                  v-model="form.bloodType"
                >
                  <option
                    v-for="(entry, index) in bloodType"
                    :key="index"
                    :value="entry.value"
                  >
                    {{ entry.label }}
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <p v-if="form.errors.length > 0" class="form_error">
              <span v-for="(error, index) in form.errors" :key="index" class="valid_error">{{ error }}</span>
            </p>
            <p>
              <button
                type="submit"
                class="btn arrow"
                :disabled="isSend"
                @click.prevent="checkForm"
              >変更する</button>
            </p>
            <p>
              <a href="#" @click.prevent="$router.go(-1)" class="arrow link_main--text">キャンセルする</a>
            </p>
          </div>
        </form>
      </ValidationObserver>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import {
  GENDERS_SELECT,
  BIRTH_YEAR_SUB_START,
  BIRTH_YEAR_SUB_END,
  BLOOD_TYPE_SELECT
} from '@/helper/constant'
import { UPDATE_USER_PROFILE } from '@/store/user/actions'

import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import {
  required,
  max
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_}を入力してください'
})

extend('max', {
  ...max,
  message: '{_field_}は{length}文字以内で入力してください'
})

extend('birthNumber', {
  validate (value) {
    return Number(value) > 0
  },
  message: '{_field_}を選択してください'
})

extend('birthDate', {
  params: ['year', 'month'],
  validate (day, { year, month }) {
    if (year === 0 || month === 0) {
      return true
    }
    const date = new Date(year, (month - 1), day)
    return (
      date.getFullYear() === year &&
      (date.getMonth() + 1) === month &&
      date.getDate() === day
    )
  },
  message: '日付が正しくありません'
})

export default {
  name: 'UserProfileChange',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      user: this.$store.getters.loginUser || {},
      genders: GENDERS_SELECT,
      bloodType: BLOOD_TYPE_SELECT,
      form: {
        errors: [],
        nickname: null,
        gender: 'u',
        birthYear: 0,
        birthMonth: 0,
        birthDay: 0,
        bloodType: 'U'
      },
      isSend: false
    }
  },
  computed: {
    years: function () {
      const dt = new Date()
      const nowYear = dt.getFullYear()
      const startYear = nowYear - BIRTH_YEAR_SUB_START
      const endYear = nowYear - BIRTH_YEAR_SUB_END

      const len = endYear - startYear
      const sequential = new Array(len)
      for (let i = 0, len = sequential.length; i <= len; i++) {
        sequential[i] = endYear - i
      }

      return sequential
    },
    months: function () {
      const len = 12
      const sequential = new Array(len)
        .fill(1)
        .map((n, i) => n + i)

      return sequential
    },
    days: function () {
      const len = 31
      const sequential = new Array(len)
        .fill(1)
        .map((n, i) => n + i)

      return sequential
    }
  },
  methods: {
    checkForm () {
      if (this.isSend) return
      this.isSend = true

      this.$refs.form.validate().then(success => {
        if (success) {
          this.updateUser()
        } else {
          this.isSend = false
        }
      })
    },
    updateUser () {
      const form = this.form
      const birthYear = form.birthYear
      const birthMonth = ('00' + form.birthMonth).slice(-2)
      const birthDay = ('00' + form.birthDay).slice(-2)
      const date = String(birthYear) + '-' + String(birthMonth) + '-' + String(birthDay)
      const params = {
        nickname: form.nickname,
        gender: form.gender,
        birthday: date,
        blood_type: (form.bloodType === 'U') ? '' : form.bloodType
      }
      this.$store.dispatch(UPDATE_USER_PROFILE, params)
        .then((data) => {
          this.$router.pushIsses({ name: 'UserProfile', params: { isProfileUpdateSuccess: true } })
        })
        .catch((error) => {
          this.isSend = false
          this.form.errors = []

          let message = ''
          if (error.errorStatus === 400) {
            message = message + '\n' + error.message
          } else if (error.errorStatus === 422) {
            Object.keys(error.errorData).forEach((key) => {
              error.errorData[key].forEach(entry => {
                this.form.errors.push(entry)
              })
            })
          } else {
            message = error.message
          }

          this.form.errors.push(message)
        })
    }
  },
  mounted () {
    this.form.nickname = this.user.user.nickname
    this.form.gender = this.user.user.gender
    if (this.user.user.birthday != null) {
      const birthday = this.user.user.birthday.replaceAll('/', '-')
      const m = moment(birthday)
      this.form.birthYear = m.year()
      this.form.birthMonth = m.month() + 1
      this.form.birthDay = m.date()
    }
    if (this.user.user.blood_type != null) {
      this.form.bloodType = this.user.user.blood_type
    }
  }
}
</script>
